import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent } from '@mui/material';
import { LoadingPanel } from './LoadingPanel';
import styled from 'styled-components';

const StyledDialog = styled(Dialog)`
  .MuiDialogContent-root {
    padding: 1rem;
  }

  .card-panel {
    border: none;
    margin: 0;
  }
`;

export const LoadingPanelModal = ({ displayMessage, message, className, open }) => (
  <StyledDialog open={open} maxWidth="sm">
    <DialogContent>
      <LoadingPanel message={message} displayMessage={displayMessage} className={className} />
    </DialogContent>
  </StyledDialog>
);

LoadingPanelModal.propTypes = {
  message: PropTypes.string,
  displayMessage: PropTypes.bool,
  className: PropTypes.string,
  open: PropTypes.bool.isRequired,
};
LoadingPanelModal.defaultProps = {
  message: 'Loading...',
  displayMessage: true,
  className: '',
};
